import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { QrCode, CreditCard } from "lucide-react";
import { PixPayment } from "./PixPayment";
import { CardPayment } from "./CardPayment";

export function CheckoutTransparente() {
  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="text-center space-y-2 mb-6">
        <h2 className="text-2xl font-heading font-bold">Assinar Pro</h2>
        <p className="text-muted-foreground">
          R$ 49,00/mês — Escolha a forma de pagamento
        </p>
      </div>

      <Tabs defaultValue="pix" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="pix" className="gap-2">
            <QrCode className="w-4 h-4" />
            PIX
          </TabsTrigger>
          <TabsTrigger value="card" className="gap-2">
            <CreditCard className="w-4 h-4" />
            Cartão
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pix">
          <PixPayment />
        </TabsContent>

        <TabsContent value="card">
          <CardPayment />
        </TabsContent>
      </Tabs>
    </div>
  );
}
